import type { OutputFormat } from '../types'

interface HeroProps {
  preset?: OutputFormat | 'default'
  onChooseFiles?: () => void
}

const HERO_COPY: Record<'default' | OutputFormat, { title: string; lead: string }> = {
  default: {
    title: 'Convert HEIC photos to JPG, PNG, or PDF',
    lead: 'Choose HEIC or HEIF files, select an output format, and download the results.',
  },
  jpg: {
    title: 'Convert HEIC to JPG',
    lead: 'Choose HEIC or HEIF files and download them as JPG images.',
  },
  png: {
    title: 'Convert HEIC to PNG',
    lead: 'Choose HEIC or HEIF files and download them as PNG images.',
  },
  pdf: {
    title: 'Convert HEIC to PDF',
    lead: 'Choose HEIC or HEIF files and combine them into a multi-page PDF.',
  },
}

export default function Hero({ preset = 'default', onChooseFiles }: HeroProps) {
  const copy = HERO_COPY[preset]

  return (
    <div className="hero-copy">
      <p className="eyebrow">HEIC / HEIF converter</p>
      <h1 id="hero-title">{copy.title}</h1>
      <p className="lead">{copy.lead}</p>
      <div className="actions">
        <button
          type="button"
          className="button"
          onClick={onChooseFiles}
          aria-label="Choose HEIC or HEIF files"
        >
          Choose HEIC files
        </button>
        <a className="secondary" href="#how">See how it works</a>
      </div>
    </div>
  )
}
